module.exports = __webpack_public_path__ + "img/layout2.4c9cedf3.png";